var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMascoteGuardarSucesso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 413.42 410.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cbcbcb;}.cls-2{fill:#e5e5e5;}.cls-3{fill:#fff;}.cls-4{fill:#fcfcfc;}.cls-5{fill:#1f8598;}.cls-6{fill:#3f3d56;}.cls-7{fill:#2f2e41;}.cls-8{fill:#e6e6e6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.25,302.23c-32.8-13.8-62.6-13.3-90.6-4.9-43.1-7.5-72.7-6.3-91.6,4.9v-34.7h182.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M316.25,292.73c-30.3-13.6-60.5-14.5-91.2,0-31.4-9-61.8-8.9-91.2,0V187.13c31.2-9.3,61.6-9,91.2,0,31.3-9,61.7-9.3,91.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.15,200.23l-1-2.6a118.82,118.82,0,0,1,23.9-5.7c12.9-1.7,32.2-2.2,50.6,5.7l-1.1,2.5c-17.7-7.6-36.4-7.2-49-5.5A117.79,117.79,0,0,0,142.15,200.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.15,209.93l-1-2.6a118.82,118.82,0,0,1,23.9-5.7c12.9-1.7,32.2-2.2,50.6,5.7l-1.1,2.5c-17.7-7.6-36.4-7.2-49-5.5A117.79,117.79,0,0,0,142.15,209.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.15,219.73l-1-2.6a118.82,118.82,0,0,1,23.9-5.7c12.9-1.7,32.2-2.2,50.6,5.7l-1.1,2.5c-17.7-7.6-36.4-7.2-49-5.5A103.12,103.12,0,0,0,142.15,219.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.15,229.43l-1-2.6a118.82,118.82,0,0,1,23.9-5.7c12.9-1.7,32.2-2.2,50.6,5.7l-1.1,2.5c-17.7-7.6-36.4-7.2-49-5.5A117.79,117.79,0,0,0,142.15,229.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.15,239.13l-1-2.6a118.82,118.82,0,0,1,23.9-5.7c12.9-1.7,32.2-2.2,50.6,5.7l-1.1,2.5c-17.7-7.6-36.4-7.2-49-5.5A117.79,117.79,0,0,0,142.15,239.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.15,248.83l-1-2.6a118.82,118.82,0,0,1,23.9-5.7c12.9-1.7,32.2-2.2,50.6,5.7l-1.1,2.5c-17.7-7.6-36.4-7.2-49-5.5A117.79,117.79,0,0,0,142.15,248.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M233.35,269.33l-1-2.6a118.82,118.82,0,0,1,23.9-5.7c12.9-1.7,32.2-2.2,50.6,5.7l-1.1,2.5c-17.7-7.6-36.4-7.2-49-5.5A120.24,120.24,0,0,0,233.35,269.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M232.45,250.73v-53.1l1-.3c24.9-7.7,49.6-7.7,73.6,0l1,.3v53l-1.9-.7c-24.9-9.3-49.1-9.3-71.7,0Zm37-10.6a107.26,107.26,0,0,1,35.8,6.5v-47c-22.8-7.1-46.3-7.1-69.9,0v46.9A94.25,94.25,0,0,1,269.45,240.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.05,277a10.36,10.36,0,0,1-5.9-1.9l-.1-.1-22-16.8a9.63,9.63,0,0,1-1.8-13.6,9.82,9.82,0,0,1,13.7-1.8l14.3,10.9,33.7-43.9a9.82,9.82,0,0,1,13.7-1.8l-.2.3.2-.3a9.62,9.62,0,0,1,1.8,13.6l-39.6,51.5A9.39,9.39,0,0,1,217.05,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51.15,107.33H400a.94.94,0,0,1,1,1v266.8a.94.94,0,0,1-1,1H150.75a1,1,0,0,1,0-2h248.3V109.33H52.25v132.4a1,1,0,1,1-2,0V108.33A.87.87,0,0,1,51.15,107.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.05,120.43a43.6,43.6,0,1,0-43.6-43.6A43.57,43.57,0,0,0,93.05,120.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M86.45,111H73.15v23.6h13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M113,111H99.65v23.6H113Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.25,139.13c6.1,0,11-1.9,11-4.1s-4.9-4.1-11-4.1-11,1.9-11,4.1S78.15,139.13,84.25,139.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M110.65,138.53c6.1,0,11-1.9,11-4.1s-4.9-4.1-11-4.1-11,1.9-11,4.1S104.55,138.53,110.65,138.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.15,80.63a14.9,14.9,0,1,0-14.9-14.9A14.94,14.94,0,0,0,94.15,80.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.25,73.83a5,5,0,1,0-5-5A5,5,0,0,0,99.25,73.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.75,36.33c-3.5-15.8,7.7-31.6,25.1-35.5s34.3,5.8,37.9,21.4-8,21.5-25.4,25.5S54.35,52.13,50.75,36.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M329.15,315.73c2.9-2.4-.9-11.9-8.5-21.1s-16.2-14.8-19.2-12.4.9,11.9,8.5,21.1S326.25,318.23,329.15,315.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M353.35,386a43.6,43.6,0,1,0-43.6-43.6A43.57,43.57,0,0,0,353.35,386Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M373.15,376.63h-13.3v23.6h13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M346.75,376.63h-13.3v23.6h13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M362.15,404.73c6.1,0,11-1.9,11-4.1s-4.9-4.1-11-4.1-11,1.9-11,4.1S356.05,404.73,362.15,404.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M335.65,404.13c6.1,0,11-1.9,11-4.1s-4.9-4.1-11-4.1-11,1.9-11,4.1S329.65,404.13,335.65,404.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M368.55,319.23c-13.8-11.3-21.4-21.7-11.1-34.2s29.8-13.3,43.5-2,16.5,30.6,6.3,43.1S382.35,330.53,368.55,319.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M338.25,334.73a14.9,14.9,0,1,0-14.9-14.9A14.94,14.94,0,0,0,338.25,334.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M333,321.13a5,5,0,1,0-5-5A5.08,5.08,0,0,0,333,321.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.75,332c-3,3-5.2,12.7-.9,17s16.7-.3,19.7-3.2-4.6-3.4-8.8-7.6S318.65,329.13,315.75,332Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M394.65,400.53c3.6-1.4,3-11.5-1.3-22.7s-10.6-19.2-14.2-17.8-3,11.5,1.3,22.8C384.75,393.93,391.15,401.93,394.65,400.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.25,96.13c0,3,7.9,9.1,16.6,9.1s16.9-8.6,16.9-11.7-8.2.6-16.9.6S78.25,93.13,78.25,96.13Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 108.08,
    cy: 316.45,
    rx: 21.5,
    ry: 6.8,
    transform: "translate(-226.1 304.44) rotate(-69.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 68.14,
    cy: 348.94,
    r: 43.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 48.54,
    y: 382.74,
    width: 13.1,
    height: 23.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 74.74,
    y: 382.74,
    width: 13.1,
    height: 23.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 59.44,
    cy: 406.44,
    rx: 10.9,
    ry: 4.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 85.64,
    cy: 405.94,
    rx: 10.9,
    ry: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 69.34,
    cy: 338.04,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 72.34,
    cy: 335.04,
    r: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M26.44,308.84c-3.5-15.6,7.6-31.3,24.8-35.1s33.9,5.7,37.4,21.2-7.9,21.3-25.1,25.2S29.94,324.44,26.44,308.84Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 19.65,
    cy: 328.9,
    rx: 6.8,
    ry: 21.5,
    transform: "translate(-285.95 205.71) rotate(-64.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47,364.44c0,4.2,10.9,12.5,22.9,12.5s23.3-11.9,23.3-16.1-11.3.8-23.3.8S47,360.24,47,364.44Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascoteGuardarSucesso);
export default __webpack_public_path__ + "static/media/mascoteGuardarSucesso.79ccf4f6e678491c633d959ef4423f65.svg";
export { ForwardRef as ReactComponent };